"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAsyncSelect = void 0;
var react_1 = require("react");
var useSelect_1 = require("./useSelect");
var debounce_1 = require("../../../helpers/debounce");
/**
 * State management for a selection component whose options are fetched
 * asynchronously.
 *
 * For static selection state management with synchronous filtering, see
 * `useSelect()`.
 */
var useAsyncSelect = function (configuration) {
    var _a = react_1.useState([]), options = _a[0], setOptions = _a[1];
    var _b = react_1.useState(false), loading = _b[0], setLoading = _b[1];
    var _c = react_1.useState(), error = _c[0], setError = _c[1];
    var timeoutRef = react_1.useRef();
    var lastSearch = react_1.useRef();
    var fetchOptions = react_1.useCallback(function (phrase) { return __awaiter(void 0, void 0, void 0, function () {
        var fetchResult, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // The intial mount can cause fetchOptions to be hit twice with an empty phrase
                    // In general it makes no sense to research if the phrase is
                    // exactly the same as the last one.
                    if (lastSearch.current === phrase) {
                        return [2 /*return*/];
                    }
                    lastSearch.current = phrase;
                    if (timeoutRef.current) {
                        clearTimeout(timeoutRef.current);
                    }
                    timeoutRef.current = setTimeout(function () {
                        setLoading(true);
                    }, 200);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, configuration.options(phrase)];
                case 2:
                    fetchResult = _a.sent();
                    if (typeof fetchResult == "object" && fetchResult.hasOwnProperty("length")) {
                        setOptions(fetchResult);
                    }
                    setError(undefined);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    if (error_1 instanceof Error) {
                        setError(error_1);
                    }
                    return [3 /*break*/, 4];
                case 4:
                    clearTimeout(timeoutRef.current);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); }, [configuration.options]);
    // Fetch options or use fallback options on initialisation
    react_1.useEffect(function () {
        if (!configuration.fallbackOptions) {
            // Value can be truthy or boolean true.
            fetchOptions("");
        }
        else if (Array.isArray(configuration.fallbackOptions)) {
            setOptions(configuration.fallbackOptions);
        }
    }, [configuration.options, configuration.fallbackOptions]);
    var debouncedSearch = react_1.useCallback(debounce_1.debounce(fetchOptions, configuration.searchDebounceMs ? configuration.searchDebounceMs : 400), [fetchOptions, configuration.searchDebounceMs]);
    var onInputChange = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            staticSelect.onInputChange(value);
            if (!configuration.filterInClient) {
                debouncedSearch(value);
            }
            return [2 /*return*/];
        });
    }); };
    var staticSelect = useSelect_1.useSelect(__assign(__assign({}, configuration), { options: options }));
    return __assign(__assign({}, staticSelect), { options: staticSelect.options, loading: loading,
        error: error,
        onInputChange: onInputChange });
};
exports.useAsyncSelect = useAsyncSelect;
//# sourceMappingURL=useAsyncSelect.js.map